export function makeBillUpfrontState(skipBillingOnAcceptance) {
    return {
        skipBillingOnAcceptance
    };
}
